import { Component } from 'react';
import PropTypes from 'prop-types';
import LoadingOverlay from '../loading-overlay/LoadingOverlay';

class RedirectExternal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      redirect: this.props.location.state && this.props.location.state.to ? this.props.location.state.to : null,
    };
  }

  render() {
    if (!this.state.redirect) {
      return (
        <div className="loading-overlay">
          <LoadingOverlay
            className="loading"
            active
            spinner
            fadeSpeed={100}
            text="Redireccionando..."
          />
        </div>
      );
    }

    window.location = this.state.redirect;
    return (
      <div className="loading-overlay">
        <LoadingOverlay
          className="loading"
          active
          spinner
          fadeSpeed={100}
          text="Redireccionando..."
        />
      </div>
    );
  }
}

RedirectExternal.propTypes = {
  location: PropTypes.object,
};

export default RedirectExternal;
